"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _loggers = require("customer-data-tracking/loggers");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _timelineIconHelper = require("crm_ui/timeline/helpers/timelineIconHelper");

var _timelineEventTypeHelper = require("crm_ui/timeline/helpers/timelineEventTypeHelper");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _TimelineCompactEvent = _interopRequireDefault(require("../events/TimelineCompactEvent"));

var _PinnedEngagementsStore = _interopRequireDefault(require("crm_ui/pinnedEngagements/stores/PinnedEngagementsStore"));

var _generalStore = require("general-store");

var _immutable = require("immutable");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var TimelineCard =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineCard, _PureComponent);

  function TimelineCard() {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineCard);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineCard).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this._isMounted = false;
    _this.state = {
      isEditing: false,
      isHovering: false
    };
    _this.handleMouseEnter = (0, _debounce.default)(100, _this._handleMouseEnter.bind((0, _assertThisInitialized2.default)(_this)));
    _this.handleMouseLeave = (0, _debounce.default)(100, _this._handleMouseLeave.bind((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(TimelineCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props = this.props,
          timelineItem = _this$props.timelineItem,
          objectType = _this$props.objectType;
      return (0, _timelineIconHelper.getTimelineIcon)(timelineItem, objectType);
    }
  }, {
    key: "_handleMouseEnter",
    value: function _handleMouseEnter() {
      if (this._isMounted) {
        this.setState({
          isHovering: true
        });
      }
    }
  }, {
    key: "_handleMouseLeave",
    value: function _handleMouseLeave() {
      if (this._isMounted) {
        this.setState({
          isHovering: false
        });
      }
    }
  }, {
    key: "handleToggleEditBody",
    value: function handleToggleEditBody() {
      var _this$props2 = this.props,
          timelineItem = _this$props2.timelineItem,
          objectType = _this$props2.objectType;
      var updatedIsEditingState = !this.state.isEditing;
      var subAction = updatedIsEditingState ? 'edit item' : 'cancel edit item';

      _loggers.CrmLogger.log('timelineCardInteraction', {
        action: 'Timeline interaction',
        subAction: subAction,
        eventType: (0, _timelineEventTypeHelper.getEventType)(timelineItem),
        type: objectType
      });

      this.setState({
        isEditing: updatedIsEditingState
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          TimelineEvent = _this$props3.TimelineEvent,
          timelineHasPinnedEngagement = _this$props3.timelineHasPinnedEngagement,
          isPinned = _this$props3.isPinned;
      var classes = (0, _classnames.default)('timeline-item-engagements ', {
        'pinned-card-container': timelineHasPinnedEngagement
      }); // re-rendering timeline events triggers renders of a bunch of stuff
      // which is sometimes nontrivial. to be safe, only attach the listeners
      // when the event is a more complex event that needs to handle hover events

      var mouseProps = TimelineEvent === _TimelineCompactEvent.default ? {} : {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      };
      return _react.default.createElement(_UICardWrapper.default, (0, _extends2.default)({}, mouseProps, {
        compact: true,
        className: classes,
        "data-selenium-test": "timeline-card-v2"
      }), _react.default.createElement(TimelineEvent, (0, _extends2.default)({}, this.props, {
        isEditing: this.state.isEditing,
        isHovering: this.state.isHovering,
        isPinned: isPinned,
        onToggleEditBody: this.handleToggleEditBody,
        icon: this.getIcon()
      })));
    }
  }]);
  return TimelineCard;
}(_PureComponent2.default);

var emailReplyPropTypes = {
  subject: _SubjectType.default
};
var propTypes = (0, _extends2.default)({
  isPinned: _propTypes.default.bool,
  objectType: _ObjectTypesType.default.isRequired,
  subjectId: _propTypes.default.string.isRequired,
  timelineHasPinnedEngagement: _propTypes.default.bool,
  timelineItem: _propTypes.default.object.isRequired,
  TimelineEvent: _propTypes.default.func.isRequired
}, emailReplyPropTypes);
var defaultProps = {
  subject: _SubjectType.default,
  isPinned: false
};
TimelineCard.propTypes = propTypes;
TimelineCard.defaultProps = defaultProps;

var _default = (0, _generalStore.connect)({
  timelineHasPinnedEngagement: {
    stores: [_PinnedEngagementsStore.default],
    deref: function deref(_ref) {
      var subject = _ref.subject;

      if (!subject) {
        return null;
      }

      var objectType = (0, _ImmutableModel.getObjectType)(subject);
      var subjectId = "" + (0, _ImmutableModel.getId)(subject);
      return !!_PinnedEngagementsStore.default.get((0, _immutable.Map)({
        objectType: objectType,
        subjectId: subjectId
      }));
    }
  }
})(TimelineCard);

exports.default = _default;
module.exports = exports.default;